import axios from 'axios';
import { tiendaApiBase } from '@/utils/tiendaApiBaseUrl';

class CategoriaService {
  /** Catálogo público Django: …/tienda/productos/categorias/ */
  getCategorias() {
    return axios.get(`${tiendaApiBase()}productos/categorias/`);
  }
}

export default new CategoriaService();
